import React, { useContext } from 'react'
import withDialog, { WrappedProps } from 'shared/hocs/withDialog'
import styled, { ThemeContext } from 'styled-components'
import { lighten } from 'polished';

import flowRight from 'lodash/flowRight'
import Button from 'shared/components/Button'
import Box from 'shared/components/Box'
import { roleSelector, organizationSettingSelector } from 'shared/hocs/withAuth'
import { useDispatch, useSelector } from 'react-redux'

interface FollowupDialogType {

}

type Props = WrappedProps<FollowupDialogType> & {
}

function FollowupDialog(props: Props) {
  const {
    onClose,
  } = props

  const theme = useContext(ThemeContext)
  const {isParticipant} = useSelector(roleSelector)
  const { organization_information } = useSelector(organizationSettingSelector)
  const message = isParticipant
    ? `your screening test answers you will be unable to participate`
    : `the screening test answers the participant will not be able to participate`
  return (
    <FollowupDialogBodyContainer className="confirm-dialog-container">
      <Box className="description" mb="24px">
        {`Sorry! Unfortunately based on ${message} in in-person ${organization_information.name} programs or events today`}
      </Box>
      <Box className="description" mb="24px">
        Please monitor {`${isParticipant ? 'your' : 'their'}`} symptoms the next 24 hours. Staff will be in touch with next steps.
        In the meantime, check out our online program hub for activities you can take part in at home
      </Box>
      <Box className="description" mb="40px">Need to get in touch? Call us at 416-637-7588</Box>
      <StyledButton
        variant="primary"
        onClick={onClose}
        px="32px"
        width="246px"
      >
        Go to Scoreboard
      </StyledButton>
      <StyledButton
        variant="outline-primary"
        onClick={() => window.open('https://www.mlselaunchpad.online/')}
        width="246px"
      >
        View Virtual Programs
      </StyledButton>
      <Box className="description" mt="-14px">This will open in a new tab</Box>
    </FollowupDialogBodyContainer>
  )
}

const WrappedFollowupDialog = flowRight(withDialog())(FollowupDialog)


const StyledButton = styled(Button)`
  margin: 0 auto;
  margin-bottom: 22px;
`

const FollowupDialogBodyContainer = styled(Box)`
  color: ${({ theme }) => theme.colors.secondary};
  padding: 40px;
  width: 100%;
  max-width: 540px;

  .description {
    width: 100%;
    text-align: center;

    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
  }
`
export default WrappedFollowupDialog
